import { DescriptionRounded, TableChartRounded } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { IPendingListRow } from "../../../../../api/services";
import { hasScope } from "../../../../../utils";
import { BookingScope } from "../../../../../types";
import { useContext } from "react";
import { GlobalContext } from "../../../../../../../util/state/GlobalContextProvider";

const CellActions = (params: ICellRendererParams<IPendingListRow>) => {

    const { t } = useTranslation('booking');

    const { globalData } = useContext(GlobalContext);

    return (
        <Stack direction="row" alignItems="center">
            { hasScope(globalData, BookingScope.AvailabilityOperation) &&
                <Link
                    to={
                        "/operation/availability/report_old?" +
                        `pickupLocationId=${params.data?.booking.pickupLocation.id}&` +
                        `pickupLocationType=LMS&` +
                        `pickupCarSegment=${params.data?.booking.carGroup.carSegment}&` +
                        `pickupCentralDatetime=${params.data?.booking.pickupDate}&` +
                        `tenant=${params.data?.booking.tenant}`
                    }
                    target="_blank"
                >
                    <IconButton title={t('label.availabilityReport')}  color="accent">
                        <TableChartRounded />
                    </IconButton>
                </Link>
            }
            <Link to={`/booking/view/${params.data?.booking.id}`} target="_blank">
                <IconButton title={t('label.details')} color="accent">
                    <DescriptionRounded/>
                </IconButton>
            </Link>
        </Stack >
    );
};

export default CellActions;
